export default __webpack_public_path__ + "static/media/heroImage.0131c65c.jpg";